import React from 'react'
import { Paper } from '@mui/material'

export default function InnerFrame({ children, sx = {} }) {
  return (
    <Paper
      sx={{
        p: 1,
        borderRadius: "10px",
        border: "1px solid #E5E7EB",
        boxShadow: `
          inset 3px 3px 4px rgba(213, 225, 243, 0.8),
          2px 2px 0px rgba(255, 255, 255, 1)
        `,
        backgroundColor: "#FBFBFF",
        ...sx,
      }}
    >
      { children }
    </Paper>
  )
}
